import { useState } from 'react';
import {
  AutoBalanceTransfer,
  AutoBalanceTransferRequest,
  AutoBalanceTransferStatus,
  CancelAutoBalanceTransferRequest,
  CreateAutoBalanceTransferRequest,
} from 'vopay';
import { api } from '@/services/api.config';

const RESOURCE_NOT_FOUND = 2002;
const ENDED_STATUSES: (AutoBalanceTransferStatus | '')[] = ['cancelled', 'completed'];

export default function useAutoBalanceTransfer() {
  const [autoBalanceTransfer, setAutoBalanceTransfer] = useState<AutoBalanceTransfer>();

  async function fetchAutoBalanceTransfer(params: AutoBalanceTransferRequest) {
    try {
      const res = await api.fetchAutoBalanceTransfer(params);

      // A currency with no schedule comes back as an error rather than an empty result.
      if (!res.Success && res.ErrorCode === RESOURCE_NOT_FOUND) {
        setAutoBalanceTransfer(undefined);

        return undefined;
      }

      if (!res.Success) throw new Error(res.ErrorMessage);

      // An ended schedule is still returned, but there's nothing left to show, edit or cancel.
      const transfer = ENDED_STATUSES.includes(res.Status) ? undefined : res;

      setAutoBalanceTransfer(transfer);

      return transfer;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function createAutoBalanceTransfer(params: CreateAutoBalanceTransferRequest) {
    try {
      const res = await api.createAutoBalanceTransfer(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function cancelAutoBalanceTransfer(params: CancelAutoBalanceTransferRequest) {
    try {
      const res = await api.cancelAutoBalanceTransfer(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return {
    autoBalanceTransfer,
    fetchAutoBalanceTransfer,
    createAutoBalanceTransfer,
    cancelAutoBalanceTransfer,
  };
}
